export default __webpack_public_path__ + "static/EuclidCircularB.bold-f28d7b92fda1e2d7b18a30061a38c156.woff";